import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function EngineeringFooter() {
  return <section data-section-id="137570" id="footer" className="bg-background text-foreground">
      <footer className="bg-primary text-primary-foreground/70 py-16 lg:py-20 font-sans">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
            
            {}
            <div className="flex flex-col gap-6">
              <Link to="/HomePage" className="inline-block w-fit">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/climavr_logo_light.png" alt="Brendon J Building Material Wholesalers Logo" className="h-7 w-auto" />
              </Link>
              <div className="flex flex-col gap-2">
                <p className="text-sm leading-relaxed max-w-xs font-sans">
                  Premium wholesale supply of building materials and hardware. Reliable bulk procurement for Australian construction projects.
                </p>
                <p className="font-mono text-[10px] tracking-wider text-primary-foreground/40 uppercase">
                  ACN: 669 488 386
                </p>
              </div>
              <div className="flex flex-col gap-3 text-sm mt-2 font-sans">
                <div className="flex items-start gap-3">
                  <MapPin className="size-4 mt-0.5 shrink-0 text-amber-500" />
                  <span>31-33 Beveridge St, Swan Hill VIC 3585, Australia</span>
                </div>
                
                <div className="flex items-center gap-3">
                  <Mail className="size-4 shrink-0 text-amber-500" />
                  <span>sales@brendonjwholesalers.com.au</span>
                </div>
              </div>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-primary-foreground font-serif font-bold tracking-tight uppercase text-sm">
                Company Navigation
              </h3>
              <ul className="flex flex-col gap-3 text-sm font-sans">
                <li>
                  <Link to="/ProductsPage" className="hover:text-amber-500 transition-colors duration-200">
                    Product Catalog
                  </Link>
                </li>
                <li>
                  <Link to="/ServicesPage" className="hover:text-amber-500 transition-colors duration-200">
                    Wholesale Services
                  </Link>
                </li>
                <li>
                  <Link to="/AboutPage" className="hover:text-amber-500 transition-colors duration-200">
                    About Our Firm
                  </Link>
                </li>
                <li>
                  <Link to="/ContactPage" className="hover:text-amber-500 transition-colors duration-200">
                    Contact & Support
                  </Link>
                </li>
              </ul>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-primary-foreground font-serif font-bold tracking-tight uppercase text-sm">
                Supply Categories
              </h3>
              <ul className="flex flex-col gap-3 text-sm font-sans">
                <li>
                  <Link to="/ProductsPage" className="hover:text-amber-500 transition-colors duration-200">
                    Cement & Concrete Supplies
                  </Link>
                </li>
                <li>
                  <Link to="/ProductsPage" className="hover:text-amber-500 transition-colors duration-200">
                    Steel & Structural Metal
                  </Link>
                </li>
                <li>
                  <Link to="/ProductsPage" className="hover:text-amber-500 transition-colors duration-200">
                    Plumbing & Piping Systems
                  </Link>
                </li>
                <li>
                  <Link to="/ProductsPage" className="hover:text-amber-500 transition-colors duration-200">
                    Electrical Hardware & Tools
                  </Link>
                </li>
              </ul>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-primary-foreground font-serif font-bold tracking-tight uppercase text-sm">
                Request a Quote
              </h3>
              <p className="text-sm mb-2 font-sans">
                Partner with us for high-volume wholesale orders and nationwide delivery logistics tailored for B2B clients.
              </p>
              <div className="flex flex-wrap gap-6 items-center">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/arc_accreditation_logo.png" alt="Australian Standards Certified" className="h-14 w-auto opacity-70 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0" />
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/airah_accreditation_logo.png" alt="Industry Partner" className="h-10 w-auto opacity-70 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0" />
              </div>
            </div>

          </div>

          <Separator className="my-10 bg-primary-foreground/10" />

          {}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 font-mono text-[10px] text-primary-foreground/40 uppercase tracking-widest">
            <p>
              &copy; {new Date().getFullYear()} BRENDON J BUILDING MATERIAL WHOLESALERS PTY LTD.
            </p>
            <div className="flex items-center gap-4">
              <Link to="#" className="hover:text-amber-500 transition-colors">Privacy Policy</Link>
              <Link to="#" className="hover:text-amber-500 transition-colors">Terms of Trade</Link>
              <span className="hidden md:inline-block text-primary-foreground/20">|</span>
              <p>Site by 10Web</p>
            </div>
          </div>
        </div>
      </footer>
    </section>;
}